(ns hai.ui.components.collection.settings
  (:require
   [hai.ui.components :as c]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.select.single-select :as single-select]
   [hai.ui.rf-sugar :refer [<s >e defevent-fx]]
   [humbleai.belt.malli.transform.translate-keys :as translate-keys]
   [lambdaisland.ornament :as o]
   [malli.util :as mu]))

(o/defstyled form-render :div
  :flex :flex-col :gap-2
  [:& :> [:div :flex :flex-row :items-center :gap-2]]
  ([{{:keys [admin? case-sensitive? show-filters-table? show-filters-card?]
      :collection/keys [view]} :form/fields}]
   (let [cards?       (= (:form.field/current-value view) :collection.view/cards)
         show-filters (if cards? show-filters-card? show-filters-table?)]
     [:<>
      (when @(<s :auth/admin?)
        [:label
         [:div
          [form/checkbox admin?]
          [c/Text "Admin view"]]])
      [:label {:key (if cards? "show-filters-card" "show-filters-table")}
       [:div
        [form/checkbox show-filters]
        [c/Text "Show filters"]]]
      [:label
       [:div
        [form/checkbox case-sensitive?]
        [c/Text {:title "sorting, search, filtering"} "Case sensitive"]]]
      [form/render-field view]])))

(def view-options
  [{:value :collection.view/table
    :title "Table"}
   {:value :collection.view/cards
    :title "Cards"}])

(defn collection-view-options
  "The selectable views for `collection`.

  A collection may declare its own switchable views as data via
  `:collection/view-options` (the `{:value :title}` shape of `view-options`);
  when it does, those are the only views offered, which is how a view is both
  opted in and pinned. A board that lists a single option (e.g. a kanban board
  declaring `[kanban/view-option]`) offers that view alone - no Table / Cards
  switcher - so the `:collection/view` enum accepts only that value and the
  board cannot flip to another view. Every other collection omits the key and
  keeps the default Table / Cards options.

  Kept generic on purpose: the specific views (kanban and any future custom
  view) live with their own namespaces and reach settings only as declared
  data, never as a special-case branch here."
  [collection]
  (or (:collection/view-options collection) view-options))

(defn form-schema
  [collection reload]
  (let [stored (:collection/stored-settings collection)
        options (collection-view-options collection)
        save-setting (fn [k v]
                       (reload)
                       (when-let [table-id (:table/id collection)]
                         (>e [:user/save-collection-setting table-id k v])))]
    [:map
     [:admin?
      {:default (get stored :admin? false)
       :on-change (partial save-setting :admin?)}
      :boolean]
     [:case-sensitive?
      {:default (get stored :case-sensitive? false)
       :on-change (partial save-setting :case-sensitive?)}
      :boolean]
     [:show-filters-table?
      {:default (get stored :show-filters-table? false)
       :on-change (partial save-setting :show-filters-table?)}
      :boolean]
     [:show-filters-card?
      {:default (get stored :show-filters-card? false)
       :on-change (partial save-setting :show-filters-card?)}
      :boolean]
     [:collection/view
      {:default (:collection.view/default collection)
       :form.field/render (fn [view]
                            [:div
                             [c/Text "View mode"]
                             [single-select/field-slim view]])
       :form.field.select/options options
       :on-change (fn [view]
                    ;; No reload: both views render off the same already-fetched
                    ;; `:table/rows`, so switching is pure presentation — re-fetching
                    ;; would be redundant and would reset pagination to page 1.
                    (when-let [k (:table/id collection)]
                      (>e [:user/save-collection-view k view])))}
      (into [:enum] (map :value) options)]]))

(defevent-fx :settings/reload-table
  [_ collection]
  {:fx [[:dispatch [:table/reset-cursors collection]]
        ;; TODO can't call `:table/resolve` as the setting hasn't been set yet in the
        ;; table.
        [:dispatch [:table/debounce-resolve collection]]]})

(defn process-schema
  ([collection-schema collection]
   (process-schema collection-schema collection nil))
  ([collection-schema {:collection/keys [type] :as collection} implementation-schema]
   ;; TODO this needs to be cleaned up, it's all an unorganised hack currently
   (let [reload (fn [& _args] (>e [:settings/reload-table collection]))]
     (cond-> collection-schema
       (= :query type)
       (conj [:table/settings
              {:default {}
               :form/render (or (:settings/render collection) form-render)
               ::translate-keys/from :settings}
              ;; TODO this merges properties and while it works leaves confusing properties in the
              ;; resulting schema
              (mu/merge
               (or (:settings/schema collection)
                   (form-schema collection reload))
               implementation-schema)])))))

(defn menu
  [{{{:table/keys [settings]} :form/fields} :table/form}]
  [c/PopoverRoot
   [c/PopoverTrigger [c/Button {:variant "ghost"} "Settings"]]
   [c/PopoverContent
    [form/component settings]]])
